<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <!-- <a-form-item label="群成员">
                <a-input placeholder="请输入群成员名称" v-model="searchObj.groupMemberName"></a-input>
              </a-form-item> -->
            <a-form-item label="客户类型">
              <a-select
                style="width: 155px"
                placeholder="请选择客户类型"
                v-model="searchObj.memberType"
              >
                <a-select-option
                  v-for="item in memberTypeOptions"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.text }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="客户名称">
              <a-input
                placeholder="请输入客户名称"
                v-model="searchObj.memberName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="手机号">
              <a-input
                placeholder="请输入手机号"
                v-model="searchObj.mobileNumber"
              ></a-input>
            </a-form-item>
          </a-col>
          <!--          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">-->
          <!--            <a-form-item label="客户经理">-->
          <!--              <a-input-->
          <!--                placeholder="请输入客户经理"-->
          <!--                v-model="searchObj.customerManager"-->
          <!--              ></a-input>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <!--          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">-->
          <!--            <a-form-item label="客户经理代码">-->
          <!--              <a-input-->
          <!--                placeholder="请输入客户经理代码"-->
          <!--                v-model="searchObj.managerCode"-->
          <!--              ></a-input>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">
            <a-form-item label="等级名称">
              <a-input
                placeholder="请输入等级名称"
                v-model="searchObj.memberGroupName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">
            <a-form-item label="客户经理">
              <a-input
                placeholder="请输入客户经理"
                v-model="searchObj.customerManager"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">
            <a-form-item label="unionid">
              <a-input
                placeholder="请输入unionid"
                v-model="searchObj.unionId"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <!--展开按钮，控制toggleSearchStatus状态-->
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
              <!--展开按钮结束-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button
        type="primary"
        icon="download"
        @click="handleExportXls('exportXlsUrl', '客户账号记录')"
        >全部导出</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item
              key="2"
              @click="handleExportXls('exportXlids', '客户账号记录')"
              ><a-icon type="download" />选择导出</a-menu-item
            >
          </a-menu>
          <a-button> 批量 <a-icon type="down" /></a-button>
        </a-dropdown>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="JumpHandleDetail(record)">查看</a>
        </span>
      </a-table>
    </div>

    <ct-mm-member-modal ref="modalForm" @ok="modalFormOk"></ct-mm-member-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { initDictOptions } from '@/components/dict/JDictSelectUtil';
import CtMmMemberModal from './modules/CtMmMemberModal';
import { filterObj } from '@/utils/util';
import { getAction, postAction, downFile } from '@/api/manage';

const columns = [
  {
    title: '名称',
    align: 'center',
    dataIndex: 'memberName',
  },
  {
    title: '微信昵称',
    align: 'center',
    dataIndex: 'userNickName',
  },
  {
    title: '客户类型',
    align: 'center',
    dataIndex: 'memberType_dictText',
  },
  {
    title: '会员手机号',
    align: 'center',
    dataIndex: 'mobileNumber',
  },
  {
    title: '客户经理',
    align: 'center',
    dataIndex: 'customerManager',
  },
  {
    title: '注册时间',
    align: 'center',
    dataIndex: 'createTime',
  },
  {
    title: '等级名称',
    align: 'center',
    dataIndex: 'memberGroupName',
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 147,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  name: 'CtMmMemberList',
  components: {
    CtMmMemberModal,
  },
  data() {
    return {
      memberTypeOptions: [],
      description: '会员管理列表页面',
      // 表头
      //--------列表页重复代码 start-------------
      searchObj: {
        memberType: '',
        memberName: '',
        mobileNumber: '',
        customerManager: '',
        managerCode: '',
        memberGroupId: '',
        unionid: '',
      },
      /* 查询折叠 */
      toggleSearchStatus: false,
      /* table选中keys*/
      selectedRowKeys: [],
      loading: false,
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      //--------列表页重复代码 end-------------
      columns,
      url: {
        list:
          process.env.VUE_APP_CMS_CUSTOMER + '/customermember/ctMmMember/list',
        exportXlsUrl:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/customermember/ctMmMember/exportXls',
        exportXlids:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/customermember/ctMmMember/exportXlids',
      },
    };
  },
  created() {
    this.loadData(1);
    this.initDictConfig();
  },
  methods: {
    initDictConfig() {
      console.log('--我才是真的方法!--');
      //初始化字典 - 客户类型
      initDictOptions('memberType').then((res) => {
        if (res.success) {
          this.memberTypeOptions = res.result;
        }
      });
    },
    JumpHandleDetail(record) {
      this.$router.push({
        path: '/customermember/ctMmMemberDetail',
        query: { id: record.id },
      });
    },
    //-----------------列表页重复代码-开始--------------
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    handleExportXls(exportXlsUrlName, fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件';
      }
      let param = { ...this.searchObj };
      let idParam = '';
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['ids'] = this.selectedRowKeys.join(',');
        idParam = `?ids=${param.ids}`;
      }
      console.log('导出参数', param);
      downFile(this.url[exportXlsUrlName] + idParam, param).then((data) => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
    loadData(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      getAction(this.url.list, params).then((res) => {
        that.loading = true;
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.loading = false;
          that.ipagination.total = res.result.total;
        }
      });
    },
    getQueryParams() {
      let param = Object.assign(this.searchObj);

      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      let str = 'id,';
      this.columns.forEach(function (value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    handleAdd: function (course) {
      console.log(course);
      if (course) {
        if (course.type == 'click') {
          course = undefined;
        }
      }

      this.$refs.modalForm.add(course);
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleDetail: function (record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '详情';
      this.$refs.modalForm.disableSubmit = true;
    },
    handleDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      let that = this;
      postAction(that.url.delete, { id: id }).then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.loadData();
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData();
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log(this.name);
      if (this.name == 'courseManageModal') {
        let courseList = selectedRowKeys;
        this.form.setFieldsValue({
          courseList,
        });
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    searchQuery() {
      this.loadData(1);
    },
    //重置
    searchReset() {
      this.searchObj = {};
      this.loadData(1);
    },
    //-----------------列表页重复代码-结束--------------
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>